<template>
  <ServiceCard 
    title="Development & Feature Work"
    subtitle="Custom development retainer packages"
    description="Transform your vision into reality with ongoing development support for new features, UI/UX updates, and system enhancements."
    to="/services/development-services"
    gradient-start="#8b5cf6"
    gradient-end="#6d28d9"
    button-text="View Retainers"
  />
</template>

<script setup>
</script>
